import { Select } from 'antd';
import type { ScopeSectionRuleTypeName } from '@ydistri/api-sdk';
import React, { useMemo } from 'react';
import type { ScopeRuleDefinition, ScopeSectionRuleDraft } from './scopeEditorModel';
import { AddRuleControl, AddRuleLabel, AddRuleRow } from './ScopeSectionRulesStyledComponents';

interface AddScopeSectionRuleProps {
  disabled?: boolean;
  ruleDefinitions: ScopeRuleDefinition[];
  rules: ScopeSectionRuleDraft[];
  onAdd: (type: ScopeSectionRuleTypeName) => void;
}

const AddScopeSectionRule: React.FC<AddScopeSectionRuleProps> = ({
  disabled = false,
  ruleDefinitions,
  rules,
  onAdd,
}) => {
  const options = useMemo(
    () =>
      ruleDefinitions.map(definition => ({
        value: definition.value,
        label: definition.label,
        disabled: rules.some(rule => rule.type === definition.value),
      })),
    [ruleDefinitions, rules],
  );

  return (
    <tr>
      <td colSpan={4}>
        <AddRuleRow>
          <AddRuleLabel>Filter by:</AddRuleLabel>
          <AddRuleControl>
            <Select<ScopeSectionRuleTypeName>
              aria-label="Add entity rule"
              data-testid="scope-add-rule"
              disabled={disabled}
              placeholder="Select entity"
              options={options}
              value={undefined}
              onChange={onAdd}
            />
          </AddRuleControl>
        </AddRuleRow>
      </td>
    </tr>
  );
};

export default AddScopeSectionRule;
